// extracted by mini-css-extract-plugin
export var body = "_3f-1";
export var bodyPadded = "_3f-2";
export var chevron = "_3f-4";
export var chevronOpen = "_3f-5";
export var header = "_3f-0";
export var icon = "_3f-3";